module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box m-h-700"
  }, [_c('div', {
    staticClass: "box-body form-inline"
  }, [_c('div', {
    staticClass: "form-group text-left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/crActivity'
      }
    }
  }, [_c('div', {
    staticClass: "btn btn-default btn-table-title"
  }, [_vm._v("新增優惠券活動")])])], 1), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.brandBrief.length > 1 && _vm.$route.name !== 'storeInfo' && _vm.ownerTypeSelect !== 1 && _vm.getRoleType !== 10) ? _c('div', {
    staticClass: "form-group",
    on: {
      "change": _vm.getAttendCoupon
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandSelect),
      expression: "brandSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.brandSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.brandBrief), function(brand) {
    return _c('option', {
      domProps: {
        "value": brand.value
      }
    }, [_vm._v("\n                " + _vm._s(brand.label) + "\n              ")])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.brandSelect !== 999999 && _vm.brandSelect !== '999999' && _vm.storeBrief.length > 1 && _vm.ownerTypeSelect !== 1 && _vm.getRoleType !== 30) ? _c('div', {
    staticClass: "form-group",
    on: {
      "change": _vm.getAttendCoupon
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.storeSelect),
      expression: "storeSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.storeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.storeBrief), function(store) {
    return _c('option', {
      domProps: {
        "value": store.value
      }
    }, [_vm._v("\n                " + _vm._s(store.label) + "\n              ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ruleCodeSelect),
      expression: "ruleCodeSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.ruleCodeSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getAttendCoupon]
    }
  }, [_c('option', {
    domProps: {
      "value": 999999
    }
  }, [_vm._v("== 活動規則 ==")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SA00001"
    }
  }, [_vm._v("消費金額滿額贈 (SA00001)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SA00002"
    }
  }, [_vm._v("消費商品數量滿額贈 (SA00002)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SA00003"
    }
  }, [_vm._v("消費指定商品滿額贈 (SA00003)")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.timeMethodSelect),
      expression: "timeMethodSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.timeMethodSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getAttendCoupon]
    }
  }, [_c('option', {
    domProps: {
      "value": 999999
    }
  }, [_vm._v("== 時間狀態 ==")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "notyet"
    }
  }, [_vm._v("未開始")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "going"
    }
  }, [_vm._v("進行中")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "end"
    }
  }, [_vm._v("已結束")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.statusSelect),
      expression: "statusSelect"
    }],
    staticClass: "form-control h-38",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.statusSelect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getAttendCoupon]
    }
  }, [_c('option', {
    domProps: {
      "value": 999999
    }
  }, [_vm._v("== 活動狀態 ==")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("初始狀態")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("編輯中")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("待上架")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("已上架")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("已下架")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive p-x-0"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped dataTable",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('activity_id')
      }
    }
  }, [_vm._v("優惠券活動 (ID)\n                    "), (_vm.sortMethod === 'activity_id') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("規則代碼")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("時間狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("活動狀態")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    }
  }, [_vm._v("擁有者")]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('start_time')
      }
    }
  }, [_vm._v("活動開始\n                    "), (_vm.sortMethod === 'start_time') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "1",
      "rowspan": "1",
      "aria-controls": "example1",
      "tabindex": "0"
    },
    on: {
      "click": function($event) {
        return _vm.checkSort('end_time')
      }
    }
  }, [_vm._v("活動結束\n                    "), (_vm.sortMethod === 'end_time') ? _c('span', [(_vm.sortToggle) ? _c('i', {
    staticClass: "fa fa-caret-up",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "fa fa-caret-down",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _c('span', [_c('i', {
    staticClass: "fa fa-sort",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('th'), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.couponList), function(coupon, index) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', {
      staticClass: "sorting_1"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": '/activityInfo/' + coupon.activity_id
      }
    }, [_vm._v("\n                      " + _vm._s(coupon.name) + " (" + _vm._s(coupon.activity_id) + ")\n                    ")])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(coupon.rule_code))]), _vm._v(" "), _c('td', [(coupon.time_method === 'notyet') ? _c('label', {
      staticClass: "label label-default"
    }, [_vm._v("未開始")]) : (coupon.time_method === 'going') ? _c('label', {
      staticClass: "label label-success"
    }, [_vm._v("進行中")]) : (coupon.time_method === 'end') ? _c('label', {
      staticClass: "label label-danger"
    }, [_vm._v("已結束")]) : _vm._e()]), _vm._v(" "), _c('td', [(coupon.status === 0) ? _c('label', {
      staticClass: "label label-default"
    }, [_vm._v("初始狀態")]) : (coupon.status === 1) ? _c('label', {
      staticClass: "label label-primary"
    }, [_vm._v("編輯中")]) : (coupon.status === 3) ? _c('label', {
      staticClass: "label label-primary"
    }, [_vm._v("待上架")]) : (coupon.status === 4) ? _c('label', {
      staticClass: "label label-success"
    }, [_vm._v("已上架")]) : _c('label', {
      staticClass: "label label-danger"
    }, [_vm._v("已下架")])]), _vm._v(" "), _c('td', [(coupon.owner_type === 1) ? _c('span', [_vm._v("平台")]) : _vm._e(), _vm._v(" "), (coupon.owner_type === 2) ? _c('span', [_vm._v(_vm._s(coupon.owner_brand_name) + " (" + _vm._s(coupon.owner_id) + ")")]) : _vm._e(), _vm._v(" "), (coupon.owner_type === 3) ? _c('span', [_vm._v(_vm._s(coupon.owner_brand_name) + " - " + _vm._s(coupon.owner_store_name) + " (" + _vm._s(coupon.owner_id) + ")")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(coupon.start_time))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(coupon.end_time))]), _vm._v(" "), _c('td', [((coupon.status === 0 || coupon.status === 1 || coupon.status === 3) && coupon.strategy_time_method === 'notyet') ? _c('button', {
      staticClass: "btn btn-success",
      on: {
        "click": function($event) {
          return _vm.orderCouponPush(coupon)
        }
      }
    }, [_vm._v("上架")]) : _vm._e(), _vm._v(" "), (coupon.status === 4) ? _c('button', {
      staticClass: "btn btn-danger",
      attrs: {
        "data-target": "#stopModal",
        "data-toggle": "modal"
      },
      on: {
        "click": function($event) {
          _vm.curCoupon = coupon
        }
      }
    }, [_vm._v("下架")]) : _vm._e()]), _vm._v(" "), _c('td', [(coupon.status === 0 || coupon.status === 1) ? _c('router-link', {
      attrs: {
        "to": '/upActivity/' + coupon.activity_id
      }
    }, [_c('button', {
      staticClass: "btn btn-primary"
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })])]) : ((coupon.status === 3 || coupon.status === 4) && coupon.time_method === 'notyet') ? _c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.orderCouponEdit(coupon)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]) : _vm._e()], 1)])
  }), 0)])]), _vm._v(" "), _c('paginate', {
    ref: "orderPaginate",
    attrs: {
      "pageAmount": _vm.pageAmount,
      "total": _vm.total,
      "isActive": _vm.isActive,
      "groupAmount": _vm.groupAmount,
      "clickPage": _vm.clickPage
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "role": "dialog",
      "id": "storesModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\"" + _vm._s(_vm.current.name) + "\"使用門市")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 p-x-0"
  }, _vm._l((_vm.current.store_list), function(store) {
    return _c('label', {
      staticClass: "label label-primary",
      staticStyle: {
        "margin-right": "5px"
      }
    }, [_vm._v(_vm._s(store.name))])
  }), 0)])]), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('m-modal', {
    staticClass: "text-left",
    attrs: {
      "option": _vm.stopOption
    },
    on: {
      "trigger": _vm.trigger
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("確定")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-289b1f47"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Marketing/UpCouponTable.vue
// module id = 2357
// module chunks = 1